import React, { useContext } from "react";
import { FormDataContext } from "./FormDataContext";
import { useNavigate } from "react-router-dom";
import "../Style/Page4.css";
import { COURSE_PLAN_LABEL, isSafeHttpUrl } from "../utilities/coursePlan";
import CoursePlanLink from "./CoursePlanLink";

const EXCLUDED_FIELDS = [
    "hasDiscount",
    "hasDiscount1",
    "hasOtherStudent",
    "confirmEmail",
    "errors",
    "lastActivityTime",
];

const FIELD_LABELS = {
    citizenship: "Քաղաքացիությունը",
    firstName: "Անուն",
    lastName: "Ազգանուն",
    patronymic: "Հայրանուն",
    passportSeries: "Անձնագրի սերիա",
    htsh: "ՀԾՀ - հանրային ծառայությունների համարանիշը",
    issuedBy: "Տրված է",
    residence: "Գրանցում",
    dataIssued: "Ե՞րբ է տրվել անձնագիրը",
    phone: "Հեռախոսահամար",
    email: "Էլ. փոստ",
    selectedCourse: "Դասընթացը",
    coursePlan: COURSE_PLAN_LABEL,
    discount: "Սահմանել վերջնական գինը",
    totalPrice: "Ընդհանուր արժեքը",
    selectedDate: "Վճարին համարժեք դասընթացի ավարտը",
    paymentMethod: "Վճարման եղանակը",
    other_student: "Ում համար եմ վճարել, ուսանողի անուն ազգանուն",
};

const Page4 = () => {
    const { formData } = useContext(FormDataContext);
    const navigate = useNavigate();

    const handleConfirm = () => {
        navigate("/sli");
    };

    const handleBack = () => {
        navigate(-1);
    };

    const getPaymentMethodLabel = (method) => {
        if (method === "full") return "Միանվագ";
        if (method === "monthly") return "Մաս մաս՝ ամսական վճարումներ կատարելով մինչև դասընթացի ավարտը";
        if (method === "paylater")
            return "Հետվճարային՝ RocketLine / PayLater / PartPay / AmeriaPay";
        return method;
    };

    const renderValue = (key, value) => {
        if (key === "paymentMethod") {
            return getPaymentMethodLabel(value);
        }

        // Hide the whole row (not just the link) when there is no valid plan.
        if (key === "coursePlan") {
            return isSafeHttpUrl(value)
                ? <CoursePlanLink href={value}>Դիտել դասընթացի պլանը</CoursePlanLink>
                : null;
        }

        // other_student ցույց ենք տալիս միայն եթե checkbox-ը true է
        if (key === "other_student" && !formData.hasOtherStudent) {
            return null;
        }

        // Discount-ի տողը ցույց ենք տալիս միայն եթե իրականում զեղչ կա
        if (key === "discount" && !formData.hasDiscount) {
            return null;
        }

        if (
            EXCLUDED_FIELDS.includes(key) ||
            value === true ||
            value === false ||
            !value ||
            (typeof value === "object" &&
                Object.values(value).every(
                    (subValue) => !subValue || subValue === true || subValue === false
                ))
        ) {
            return null;
        } else if (typeof value === "object") {
            return (
                <ul>
                    {Object.entries(value).map(([subKey, subValue]) =>
                        subValue && subValue !== true && subValue !== false ? (
                            <li key={subKey}>
                                {FIELD_LABELS[subKey] || subKey}: {subValue}
                            </li>
                        ) : null
                    )}
                </ul>
            );
        } else if (key === "discount" || key === "totalPrice") {
            return `${value} ֏`;
        } else {
            return value;
        }
    };

    // formData-ի key-երից կազմում ենք ցուցակը, բացի totalPrice-ից, որը միշտ
    // ցույց ենք տալիս վերջում՝ առանձին, որպեսզի պայմանագրում միանշանակ
    // երևա վերջնական գումարը (նախկինում այս տողն ընդհանրապես բացակայում էր)։
    const orderedKeys = Object.keys(formData).filter((key) => key !== "totalPrice");

    return (
        <div className="page4">
            <div className="container1">
                <h1>Տվյալների հաստատում</h1>
                <p>
                    Խնդրում ենք ստուգել Ձեր տրամադրած բոլոր տվյալները, եթե ճիշտ են սեղմե՛ք
                    «ՀԱՍՏԱՏԵԼ» կոճակը
                </p>

                <ul>
                    {orderedKeys.map((key) => {
                        const rendered = renderValue(key, formData[key]);
                        return rendered ? (
                            <li key={key}>
                                <strong>{FIELD_LABELS[key] || key}:</strong> {rendered}
                            </li>
                        ) : null;
                    })}
                    {formData.totalPrice !== undefined && formData.totalPrice !== "" && (
                        <li>
                            <strong>Ընդհանուր արժեքը.</strong> {formData.totalPrice} ֏
                        </li>
                    )}
                </ul>

                <div className="btn_b_n btn_b_n_m">
                    <button type="button" className="submit-btn" onClick={handleBack}>
                        Նախորդ էջ
                    </button>
                    <button type="button" onClick={handleConfirm} className="submit-btn">
                        Հաստատել տվյալների ճշգրտությունը
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Page4;
